import { render, staticRenderFns } from "./ReportAction.vue?vue&type=template&id=469e1f0b&"
import script from "./ReportAction.vue?vue&type=script&lang=ts&"
export * from "./ReportAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports